import { RouteRecordRaw } from 'vue-router';
import { SETTING_ROUTE_NAME } from '@/libs/route-name';

export const settingRoute = (): RouteRecordRaw => ({
    path: '',
    name: SETTING_ROUTE_NAME.SETTING,
    component: () => import('@/pages/setting/index.vue'),
});